import styles from './style.module.css';
import { Logo } from './components/logo'
import { Divider } from './components/divider'
import { FilterButton } from './components/filter-button'
import DateRangePicker from './components/date-range-picker'
import { NewOrderButton } from './components/new-order-menu-button'
import { BulkImportButton } from './components/bulk-import-button'
import { OrderTypeFilter } from './components/order-type-filter'
import { MonitoringButton } from './components/monitoring-button'
import { Profile } from './components/profile'
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../design-system/lib/Button';
import { DRIVER_COLOR, Export, IMPORT_ICON, PLUS, Plus_Dark, Refresh_Table, Settings, SliderClose, SliderOpens } from '../../../assets';
import { ChangeNewTravelDialoge, SetDriverListOpenDialoge } from '../../../Redux/actions/actionNames';
import { ServicesVehicletypeAction } from '../../../Redux/actions/actions';
import { Link } from "react-router-dom";
import Switch from '../../../design-system/lib/Switch';
import InputFilter from '../../../design-system/lib/InputFilter';
import PhoneFilter from '../../../design-system/lib/PhoneFilter';
import CheckBoxFilter from '../../../design-system/lib/CheckBoxFilter';
import RadioButtonFilter from '../../../design-system/lib/RadioButtonFilter';
import DateFilter from '../../../design-system/lib/DateFilter';
import React, { useState } from 'react';
import TableListColumnSetting from '../../table/table-list-column-setting';
import history from '../../../service/history';
import { getTableOrderList } from '../../shared/table/action/getTableOrderList';
import { LearnMore } from '../../learnMore';
import { useTranslation } from 'react-i18next';
import { SearchBar } from '../order-list/components/search-bar';
import TableAddRoute from '../../table/selectedOrders/components/addRoute';
import { padding } from 'polished';
import CircleArrowButton from '../../../design-system/lib/CircleArrowButton';
import useGoToNewOrder from '../../../hooks/useneworder';
import { GetUserAccess } from '../../../helper/module';

export const Navbar = ({ isViewOrder }) => {
    const mapRef = useSelector((state) => state.Map.mapRef)
    const ActiveOrderType = useSelector((state) => state.OrderList.ActiveOrderType)
    const ordersListOpen = useSelector((state) => state.SharedData.ordersListOpen)
    const driversListOpen = useSelector((state) => state.SharedData.driversListOpen)
    const openDialoge = useSelector((state) => state.DriversList.openDialoge)
    const EditOrderOpenDialoge = useSelector((state) => state.EditOrder.OpenDialoge)
  const intercomData = useSelector((state) => state.SharedData.settings?.intercomData)

 
    const [showAddRoute, setShowAddRoute] = useState(false);

     const dispatch = useDispatch();
    const center = useSelector((state) => state.Map.center)
    // const [filter1, setFilter1] = useState(null);
    // const [filter1state, setFilter1state] = useState("Isequal");
    // const [filter2, setFilter2] = useState(null);
    // const [filter3, setFilter3] = useState([]);
    // const [filter4, setFilter4] = useState(null);
    // const [filter5, setFilter5] = useState({ from: null, to: null });
    const Globalsettings = useSelector((state) => state.SharedData.settings)
    const DriversListopenDialoge = useSelector((state) => state.DriversList.openDialoge)
    const { t } = useTranslation();
  const { goToNewOrder } = useGoToNewOrder({
    targetPath: '/neworder',
    useReplace: false,      // یا true به دلخواه
    debounceMs: 600,
    avoidDuplicates: true,
  });

    function NewTravelHandler() {

        if(String(window.location.pathname).includes("routes")){
            setShowAddRoute(true)
        }else {
        dispatch(ServicesVehicletypeAction(dispatch, center))
        // dispatch(ChangeNewTravelDialoge());
        goToNewOrder()
        }
  
    };



    function isMapSectionPickupDelivery() {
        if (String(window.location.href).includes("/map")) {
            return true
        } else {
            return false
        }
    };


const canshowLeftCollapse = () => {

  if(EditOrderOpenDialoge){
    return false
  }
  const path = window.location.pathname;

  // لیست مسیرهای مجاز (true) یا بستن منو
  const allowedPrefixes = ["/Ondemand", "/Delivery", "/Pickup", "/neworder", "/order/", "/route/"];

  // اگر مسیر ناوبری با "/PickupDelivery" یا زیرمسیرهای آن آغاز می‌شود، false بده
  if (path === "/PickupDelivery" || path.startsWith("/PickupDelivery/")) {
    return false;
  }

  // برای سایر مسیرها بررسی با StartsWith تا پوشش زیرمسیرها را هم بدهد
  return allowedPrefixes.some(prefix => path.startsWith(prefix));
};


const isInViewOrder = () => {
  const path = window.location.pathname;

  // لیست مسیرهای مجاز (true) یا بستن منو
  const allowedPrefixes = [  "/order/" ];

 

  // برای سایر مسیرها بررسی با StartsWith تا پوشش زیرمسیرها را هم بدهد
  return allowedPrefixes.some(prefix => path.startsWith(prefix));
};

const canshowNeworderButton = () => {
  const path = window.location.pathname;

  // لیست مسیرهای مجاز (true) یا بستن منو
 
  // اگر مسیر ناوبری با "/PickupDelivery" یا زیرمسیرهای آن آغاز می‌شود، false بده
     if((GetUserAccess().loaded && GetUserAccess().newRoute) && String(window.location.pathname).includes("routes")){
 return true;
    }else{
 
  // لیست مسیرهای مجاز (true) یا بستن منو
  const allowedPrefixes = ["/Ondemand", "/Delivery", "/Pickup", "/neworder", "/PickupDelivery", "/order/" ];

 
  // برای سایر مسیرها بررسی با StartsWith تا پوشش زیرمسیرها را هم بدهد
  return (GetUserAccess().loaded && GetUserAccess().newOrder) && allowedPrefixes.some(prefix => path.startsWith(prefix));
    }
   
 
};


const canshowDateRange = () => {
  const path = window.location.pathname;

  // لیست مسیرهای مجاز (true) یا بستن منو
  const allowedPrefixes = ["/Ondemand", "/Delivery", "/Pickup", ];

  // اگر مسیر ناوبری با "/PickupDelivery" یا زیرمسیرهای آن آغاز می‌شود، false بده
  if (path === "/PickupDelivery" || path.startsWith("/PickupDelivery/")) {
    return false;
  }

  // برای سایر مسیرها بررسی با StartsWith تا پوشش زیرمسیرها را هم بدهد
  return allowedPrefixes.some(prefix => path.startsWith(prefix));
};


const canshowPickupDeliveryItems = () => {
  const path = window.location.pathname;

  // لیست مسیرهای مجاز (true) یا بستن منو
 
  // اگر مسیر ناوبری با "/PickupDelivery" یا زیرمسیرهای آن آغاز می‌شود، false بده
  if (path === "/PickupDelivery" || path.startsWith("/PickupDelivery/")) {
    return true;
  }else{
    return false
  }

  // برای سایر مسیرها بررسی با StartsWith تا پوشش زیرمسیرها را هم بدهد
 };




  function handleAddRote(e, route) {
    setShowAddRoute(e)
  }


  const toggleDriverList = React.useCallback(() => {
     dispatch(SetDriverListOpenDialoge(!openDialoge))
    try {
      setTimeout(() => {
        mapRef?.current?.leafletElement._onResize();
      }, 350);

    } catch (error) {

    }
  }, [mapRef , openDialoge]);


 
     return <div className={clsx(styles.navbarContainer /*, (openNewOrder || isViewOrder) && styles.hideNavbarContainer */)}>
        <div className={styles.leftItems}>
            {canshowLeftCollapse() && <>

              <CircleArrowButton isOpen={ordersListOpen} size='24px' onClick={() => { dispatch({ type: "ordersListOpen", state: ordersListOpen ? false : true }) }} style={{marginInlineStart : (!ordersListOpen && isInViewOrder()) && "64px"}} />
 
            <Divider />
            </>}

           
            {/* <SearchBar />

            <Divider />

            <LearnMore placement={'bottomEnd'} className={styles.customLearnMore} where={ActiveOrderType + "OrderList"} hastext={false} /> */}
            {canshowPickupDeliveryItems() && <>
                <Switch className={styles.customswitch} handleSelection={(e) => { e == 0 ? history.push("/PickupDelivery") : history.push("/PickupDelivery/map") }} index={isMapSectionPickupDelivery() ? 1 : 0} items={[t("Table"), t("Map")]} type='topMenu' />
            </>}
            {canshowPickupDeliveryItems() && <>
                <Button size='Medium' type='Secondary' icon={Refresh_Table} style={{ backgroundColor: "unset" , padding :"7px 6px" }} onClick={() => getTableOrderList(null, null, "PickupDelivery")} />

            </>}

                {(canshowPickupDeliveryItems() && intercomData) && <>
              <Divider />
               <LearnMore placement={'bottomEnd'} className={styles.customLearnMore} where={ActiveOrderType + "OrderList"} hastext={false} />


            </>}

            {canshowDateRange() && <>
                {/* <FilterButton /> */}
                <DateRangePicker />
            </>}
            {/* <div className={styles.middleItems}>
            <OrderTypeFilter/>
        </div> */}
        </div>


        <OrderTypeFilter />

        <div className={styles.rightItems}>
            {/* <BulkImportButton /> */}
            {/* <MonitoringButton/> */}


            {ActiveOrderType == "PickupDelivery" && <TableListColumnSetting />}
            {/* <Divider /> */}
            {
                // Globalsettings.role?.haveAdminAccess && <a href={'admin/home'}> <Button size='Medium' type='Secondary' icon={Settings} text={"Admin"} /></a>
            }
            {/* <Button size='Medium' type='Secondary' text='Export' icon={Export} disabled={true} /> */}

            {GetUserAccess().newOrder && <Link to="/BulkImport" >
                <Button size='Small' type='Secondary' icon={IMPORT_ICON} style={{padding :"7px"}} />
            </Link>}
            {canshowNeworderButton()  && <Button size='Small' style={{padding :"7px"}} type='Primary' icon={PLUS} onClick={NewTravelHandler} />}

            {/* <Divider />
            <Button size='Medium' type='Secondary' text='Drivers' icon={DRIVER_COLOR} onClick={()=>{  dispatch(SetDriverListOpenDialoge(!DriversListopenDialoge))}} /> */}

            <Divider />
                          <CircleArrowButton isOpen={!openDialoge} size='24px'onClick={toggleDriverList}  />

            </div>


                  {showAddRoute && <TableAddRoute onClose={handleAddRote} />}

    </div>

};




